import styled from 'styled-components';

export const StyledButtonWrapper = styled.div`
  padding-top: 40px;
  margin: 0 auto;

  width: 480px;

  display: flex;
  justify-content: space-between;
`;
